import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import { IconWithLabelDisplay } from '../components/iconWithLabelDisplay';
import { GREEN_COLOR } from '../styles/colors';
export const SpecialEventIndicator = () => {
    return (_jsx(IconWithLabelDisplay, { label: 'Special Event', isInline: true, color: GREEN_COLOR, icon: _jsx(AutoAwesomeRoundedIcon, {}) }));
};
